module.exports = __webpack_public_path__ + "media/images/athletes/1476-17cbd5bba1bf189bbeea4b19264848a2.png";